export enum QueryKeys {
  REPORTS = 'reports',
}
